/* 布局 */
//前台
import Layout from "@views/layout";

const questiontypeRouter = {
path: "/business",
component: Layout,
redirect: {
name: "BUSINESS"
},
children: [
                {
            path: "questiontype/list",
            name: "QUESTIONTYPE",
            meta: {
            title: "题库试题分类",
            },
            component: () => import("@views/business/questiontype/index.vue"),
            },
            ],
};

export default questiontypeRouter;
